import { Helmet } from "react-helmet-async";
import { brandConfig } from "../config/brandConfig";
import { Product } from "data/products";

type CategorySEOProps = {
  products: Product[];
  canonicalPath: string;
  categoryName: string;
  description: string;
};

export default function CategorySEO({
  products,
  canonicalPath,
  categoryName,
  description,
}: CategorySEOProps) {
  const { NDD, brandName } = brandConfig;
  const categorySchema = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "@id": `${NDD}${canonicalPath}#collection`,
      name: categoryName,
      description: description,
      url: `${NDD}${canonicalPath}`,
      isPartOf: {
        "@type": "WebSite",
        name: brandName,
        url: NDD,
      },
      mainEntity: {
        "@id": `${NDD}${canonicalPath}#items`,
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "@id": `${NDD}${canonicalPath}#items`,
      isPartOf: { "@id": `${NDD}${canonicalPath}#collection` },
      itemListOrder: "https://schema.org/ItemListOrderAscending",
      numberOfItems: products.length,
      itemListElement: products.map((product, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: product.name,
        "@id": `${NDD}/produits/${product.slug}#product`,
      })),
    },
  ];

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(categorySchema)}
      </script>
    </Helmet>
  );
}
